import React from 'react';

interface BadgeProps {
  children: React.ReactNode;
  variant?: 'default' | 'gold' | 'premium';
  className?: string;
}

export const Badge = ({ children, variant = 'default', className = '' }: BadgeProps) => {
  const variantStyles = {
    default: 'bg-primary-900/50 text-primary-200 border-primary-700',
    gold: 'bg-accent-gold/10 text-accent-gold border-accent-gold/30',
    premium: 'liquid-glass-dark text-accent-gold border-accent-gold/20',
  };

  return (
    <span
      className={`
        text-xs px-3 py-1 rounded-full border
        inline-flex items-center
        ${variantStyles[variant]}
        ${className}
      `}
    >
      {children}
    </span>
  );
};
